import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import './BarraBuscaControlled.css';

import SpinnerLoading from '../SpinnerLoading';
import lupaIcon from '../../imagens/lupaIcon.png'
import { useClickOutside } from '../../hooks/clickOutside';
import { toastErrorPydantic } from '../../util/toast_pydantic';

import { useEffect, useRef, useState } from 'react';
import { servGetEstabelecimentos } from '../../servicos/estabelecimento';

function BarraBuscaControlled({ id, estabelecimento, onChange, estabelecimentosVigentes, apenasQueEnviamRelatorio }) {

  const [estabelecimentos, setEstabelecimentos] = useState(null);

  const [loading, setLoading] = useState(false);
  const [resultadoBusca, setResultadoBusca] = useState([]);
  const [controladorValueInput, setControladorValueInput] = useState('');

  const monitoraCliqueFora = useRef(null);

  useEffect(() => {
    getEstabelecimentos()
  }, []);

  useClickOutside(monitoraCliqueFora, () => limparResultadoBusca());

  const handlerBusca = async (searchTerm) => {
    setControladorValueInput(searchTerm)
    if (searchTerm.length >= 3) {
      try {
        setLoading(true);
        const estabelecimentosDaApi = await servGetEstabelecimentos(searchTerm, estabelecimentosVigentes, apenasQueEnviamRelatorio)
        setResultadoBusca(estabelecimentosDaApi)
      } catch (erro) {
        toastErrorPydantic(erro);
      } finally {
        setLoading(false);
      }
    }
  };

  async function getEstabelecimentos() {
    try {
      const estabelecimentosDaApi = await servGetEstabelecimentos(null, estabelecimentosVigentes, apenasQueEnviamRelatorio);
      setEstabelecimentos(estabelecimentosDaApi);
    } catch (erro) {
      toastErrorPydantic(erro);
    }
  }

  const limparResultadoBusca = () => {
    setResultadoBusca([])
  };

  const handlerSelect = (estabelecimento) => {
    setResultadoBusca([])
    onChange(estabelecimento)
  };

  const listarTudo = () => {
    if (!resultadoBusca) toast.error('Problema ao listar estabelecimentos/unidades')
    setResultadoBusca(estabelecimentos)
  };

  const resetInfo = () => {
    onChange(null)
  };

  return (

    <div className='d-flex flex-column flex-md-row gap-3 align-items-center' ref={monitoraCliqueFora} id={id}>
      <div className='position-relative w-100'>
        <input
          className='form-control text-center'
          value={(controladorValueInput)}
          onChange={(e) => handlerBusca(e.target.value)}
          onBlur={() => setControladorValueInput('')}
          placeholder={estabelecimento?.nome || 'Unidade não selecionada'}
        />

        <div className='resultado-busca'>
          {loading ? (
            <div className='div-com-borda p-1'>
              <SpinnerLoading mensagemLoading='Carregando' />
            </div>
          ) : resultadoBusca && (
            <ul className='list-group-flush text-center m-0 p-0'>
              {resultadoBusca.map((estabelecimento) => (
                <li
                  className='list-group-item resultado-busca-item p-2'
                  key={estabelecimento.id}
                  onClick={() => handlerSelect(estabelecimento)}
                >
                  {estabelecimento.nome}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className='d-flex gap-2'>
        <button className='text-nowrap btn btn-primary' type='button' onClick={listarTudo}>
          LIST TUDO
        </button>

        <button className='text-nowrap btn btn-primary' type='button' onClick={resetInfo}>
          LIMPAR
        </button>
      </div>
    </div>

  );
};

export default BarraBuscaControlled;

BarraBuscaControlled.propTypes = {
  onChange: PropTypes.func.isRequired,
  estabelecimentosVigentes: PropTypes.bool.isRequired,
  apenasQueEnviamRelatorio: PropTypes.bool.isRequired
};